import API from '../../sunwiseAPI';
const ENTITY = 'catalogs';

export const getRateDivisions = (data) =>
    API.get(`/api/v1/${ENTITY}/0/public/`, {
        params: { political_division: data?.political_division },
    });
export const getRegionsByPoliticalDivision = (data) =>
    API.get(`/api/v1/${ENTITY}/1/public/`, {
        params: { political_division: data?.political_division },
    });
export const getSummerMonths = () => API.get(`/api/v1/${ENTITY}/2/public/`);
